import { render, staticRenderFns } from "./AddUserReturnGoodsPopup.vue?vue&type=template&id=f42e4304"
import script from "./AddUserReturnGoodsPopup.vue?vue&type=script&lang=js"
export * from "./AddUserReturnGoodsPopup.vue?vue&type=script&lang=js"
import style0 from "./AddUserReturnGoodsPopup.vue?vue&type=style&index=0&id=f42e4304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports